import { makeStyles } from "@material-ui/core";
import React from "react";
const useStyles = makeStyles({
    childContainer: ({ appBarHeight }) => ({
        // Cast to number safely because we have defined defaultProp value.
        marginTop: appBarHeight,
    }),
});
export default function SuspenseLayout({ appBar, appBarHeight, children, }) {
    const classes = useStyles({ appBarHeight });
    return (React.createElement(React.Fragment, null,
        appBar,
        React.createElement("div", { className: classes.childContainer }, children)));
}
const defaultProps = {
    appBarHeight: 100,
};
SuspenseLayout.defaultProps = defaultProps;
//# sourceMappingURL=index.js.map